var parent = require('../../es/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-own-property-symbols.js
// module id = 553
// module chunks = 0 1